module.exports = __webpack_public_path__ + "media/img/android-icon-192x192 - Copy-aee1b8f6fa8af7a7abaa319842925432.png";